const ARRAY_FIELD_PRIORITY = [
  "target_review_pdfs",
  "review_documents",
  "documents",
  "approval_products",
  "products",
  "registrations",
  "trials",
  "articles",
  "compounds",
  "results",
  "reference_drugs",
];

function csvValue(value: unknown): string {
  if (value === null || value === undefined) return "";

  const text =
    typeof value === "object" ? JSON.stringify(value) : String(value);

  return `"${text.replace(/"/g, '""')}"`;
}

function normalizeRows(data: Record<string, unknown>): Record<string, unknown>[] {
  for (const field of ARRAY_FIELD_PRIORITY) {
    const value = data[field];
    if (Array.isArray(value) && value.length > 0) {
      return value.map((item) =>
        item && typeof item === "object" && !Array.isArray(item)
          ? (item as Record<string, unknown>)
          : { value: item },
      );
    }
  }

  return [data];
}

export function buildCsv(data: Record<string, unknown>): string {
  const rows = normalizeRows(data);
  const headers = Array.from(
    new Set(rows.flatMap((row) => Object.keys(row))),
  );

  return [
    headers.map(csvValue).join(","),
    ...rows.map((row) => headers.map((header) => csvValue(row[header])).join(",")),
  ].join("\r\n");
}

export function getSourceUrl(
  sourceId: string,
  data?: Record<string, unknown>,
): string {
  if (!data) return "";

  const fields =
    sourceId === "fda" || sourceId === "fda_drugs"
      ? ["openfda_url", "source_url", "search_url"]
      : [
          "source_url",
          "search_url",
          "openfda_url",
          "psg_url",
          "fda_psg_page_url",
          "doc_url",
          "page_url",
        ];

  for (const field of fields) {
    const value = data[field];
    if (typeof value === "string" && /^https?:\/\//i.test(value.trim())) {
      return value.trim();
    }
  }

  return "";
}

export function safeDownloadName(value: string): string {
  const cleaned = value
    .trim()
    .replace(/[<>:"/\\|?*\u0000-\u001f]/g, "_")
    .replace(/\s+/g, "_");

  return cleaned || "query_result";
}
